module.exports = __webpack_public_path__ + "static/media/FESLogo.fe7ade9b.png";